"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthenticationContext = exports.AuthenticationActionsContext = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _notistack = require("notistack");

var _reactI18next = require("react-i18next");

var _Pc2 = require("@jobmatchme/amplify-tools/es/api/Pc");

var _cognitoMessages = require("@jobmatchme/utils/es/cognitoMessages");

var _Route = require("../Route");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AuthenticationContext = /*#__PURE__*/_react.default.createContext({
  isLoading: false,
  isAuthenticated: false,
  user: null
});

exports.AuthenticationContext = AuthenticationContext;

var AuthenticationActionsContext = /*#__PURE__*/_react.default.createContext({
  forgotPassword: function forgotPassword() {
    return Promise.resolve(false);
  },
  sendDeactivatedProfileEmail: function sendDeactivatedProfileEmail() {
    return Promise.resolve(false);
  },
  resendVerificationEmail: function resendVerificationEmail() {
    return Promise.resolve(false);
  },
  resetPassword: function resetPassword() {
    return Promise.resolve();
  }
});

exports.AuthenticationActionsContext = AuthenticationActionsContext;

var AuthenticationProvider = function AuthenticationProvider(_ref) {
  var children = _ref.children;
  var authentication = (0, _Pc.useAmplifyUser)();

  var _useContext = (0, _react.useContext)(_Route.RouteActionsContext),
      routeExternal = _useContext.routeExternal,
      routeInternal = _useContext.routeInternal;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var defaultSeverity = 'warning';
  var showMessage = (0, _react.useCallback)(function (_ref2) {
    var text = _ref2.text,
        _ref2$severity = _ref2.severity,
        severity = _ref2$severity === void 0 ? defaultSeverity : _ref2$severity;
    enqueueSnackbar(t(text), {
      variant: severity,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    });
  }, [enqueueSnackbar, t]);
  var resendVerificationEmail = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(username) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _Pc2.PcApi;
              _context.t1 = "/userService/pc/".concat(username, "/resendVerificationEmail");
              _context.next = 4;
              return _Pc2.PcApi.cognitoToken();

            case 4:
              _context.t2 = _context.sent;
              _context.t3 = {
                accessToken: _context.t2
              };
              return _context.abrupt("return", _context.t0.post.call(_context.t0, _context.t1, _context.t3).then(function () {
                showMessage({
                  text: 'pc-matching:AccountVerification.sent',
                  severity: 'Success'
                });
              }).catch(function (err) {
                console.error('err', err);
                showMessage((0, _cognitoMessages.selectPcMessage)({
                  error: err,
                  severity: 'Error',
                  formName: 'generic'
                }));
                return false;
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [showMessage]);
  var forgotPassword = (0, _react.useCallback)(function (email) {
    return _Pc2.PcApi.post('/userService/pc/forgotPassword', {
      email: email
    }).then(function () {
      return true;
    }).catch(function (err) {
      console.error('err', err);
      showMessage((0, _cognitoMessages.selectPcMessage)({
        error: err,
        severity: 'Error',
        formName: 'generic'
      }));
      return false;
    });
  }, [showMessage]);
  var sendDeactivatedProfileEmail = (0, _react.useCallback)(function (email) {
    return _Pc2.PcApi.post('/userService/pc/sendDeactivatedProfileEmail', {
      email: email
    }).then(function () {
      return true;
    }).catch(function (err) {
      console.error('email send error', err);
      return false;
    });
  }, []);
  var resetPassword = (0, _react.useCallback)(function (email, code, newPassword) {
    var successMessage = 'pc-matching:ResetPasswordForm.Validate.Success.password';
    return _Pc2.PcApi.post('/userService/pc/resetPassword', {
      email: email,
      code: code,
      newPassword: newPassword
    }).then(function (result) {
      showMessage({
        text: successMessage,
        severity: 'Success'
      });
      setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var PcAuth;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _Pc2.PcApi.auth();

              case 2:
                PcAuth = _context2.sent;
                PcAuth.signIn(email, newPassword).then(function () {
                  return result === 'optin' ? routeExternal('pcoptin') : routeInternal('appHome');
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 2000);
    }).catch(function (e) {
      console.error('err', e);
      showMessage((0, _cognitoMessages.selectPcMessage)({
        error: e,
        severity: 'Error',
        formName: 'generic'
      }));
      return false;
    });
  }, [showMessage, routeExternal, routeInternal]);
  var actions = (0, _react.useMemo)(function () {
    return {
      forgotPassword: forgotPassword,
      sendDeactivatedProfileEmail: sendDeactivatedProfileEmail,
      resendVerificationEmail: resendVerificationEmail,
      resetPassword: resetPassword
    };
  }, [forgotPassword, sendDeactivatedProfileEmail, resendVerificationEmail, resetPassword]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthenticationActionsContext.Provider, {
    value: actions,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthenticationContext.Provider, {
      value: authentication,
      children: children
    })
  });
};

var _default = AuthenticationProvider;
exports.default = _default;